(() => {
  $(document).on("click", ".video_play_button", function () {
    const box = $(this).closest(".social-proof-box");
    const video = box.find("video");

    const popup = document.createElement("div");
    popup.classList.add("social-proof-popup");

    const container = document.createElement("div");
    container.classList.add("social-proof-popup-container");

    const closeBtn = document.createElement("div");
    closeBtn.classList.add("social-proof-popup-close");
    closeBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M320 576C461.4 576 576 461.4 576 320C576 178.6 461.4 64 320 64C178.6 64 64 178.6 64 320C64 461.4 178.6 576 320 576zM231 231C240.4 221.6 255.6 221.6 264.9 231L319.9 286L374.9 231C384.3 221.6 399.5 221.6 408.8 231C418.1 240.4 418.2 255.6 408.8 264.9L353.8 319.9L408.8 374.9C418.2 384.3 418.2 399.5 408.8 408.8C399.4 418.1 384.2 418.2 374.9 408.8L319.9 353.8L264.9 408.8C255.5 418.2 240.3 418.2 231 408.8C221.7 399.4 221.6 384.2 231 374.9L286 319.9L231 264.9C221.6 255.5 221.6 240.3 231 231z"/></svg>`
    closeBtn.addEventListener("click", function () {
      popup.remove();
    });
    container.append(closeBtn);

    const clonedVideo = video.clone();
    clonedVideo.prop("controls", true);
    clonedVideo.appendTo($(container));
    clonedVideo.get(0).play();

    popup.append(container);

    popup.addEventListener("click", function (e) {
      if (e.currentTarget == e.target) {
        popup.remove();
      }
    });

    document.body.append(popup);
  });
})();
